import { render, staticRenderFns } from "./DecisionActs.vue?vue&type=template&id=e01b7904&scoped=true&"
import script from "./DecisionActs.vue?vue&type=script&lang=js&"
export * from "./DecisionActs.vue?vue&type=script&lang=js&"
import style0 from "./DecisionActs.vue?vue&type=style&index=0&id=e01b7904&scoped=true&lang=css&"
import style1 from "./DecisionActs.vue?vue&type=style&index=1&lang=scss&"
import style2 from "@/styles/items.scss?vue&type=style&index=2&id=e01b7904&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e01b7904",
  null
  
)

export default component.exports